import React from "react";
import { Chip, styled } from "@mui/material";

// Overlays the top-right corner of the host element, which must set `position: relative`.
// Clicks pass through so the badge never swallows an interaction on the element behind it.
const PositionedChip = styled(Chip)({
    position: 'absolute',
    top: -10,
    right: -10,
    zIndex: 1,
    height: 20,
    fontSize: '0.7rem',
    fontWeight: 700,
    pointerEvents: 'none',
    '& .MuiChip-label': {
        paddingLeft: 8,
        paddingRight: 8,
    },
});

interface NewBadgeProps {
    label?: string;
}

export default function NewBadge({ label = "New" }: NewBadgeProps) {
    return <PositionedChip label={label} color="success" size="small" aria-hidden />;
}
